/**
 * Helpers for primary/contingent beneficiary list questions.
 */

import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';

const BENE_TYPE_BASE_IDS = ['PrimaryBeneType', 'ContingentBeneType'];

const BENEFIT_PERCENTAGE_BASE_IDS = ['BenefitPercentage', 'ContingentBenefitPercentage', 'PrimaryBenefitPercentage'];

const stripNumericSuffix = (questionId) => {
  if (!questionId) return '';
  return questionId.replace(/_\d+$/, '');
};

export const isBeneTypeQuestionId = (questionId) =>
  BENE_TYPE_BASE_IDS.includes(stripNumericSuffix(questionId));

export const isBenefitPercentageQuestionId = (questionId) =>
  BENEFIT_PERCENTAGE_BASE_IDS.includes(stripNumericSuffix(questionId));

/**
 * Resolve BenefitPercentage_* id for the same list row as the bene-type question.
 */
export const getBenefitPercentageQuestionId = (beneTypeQuestionId, listIndex) => {
  const isContingent = stripNumericSuffix(beneTypeQuestionId) === 'ContingentBeneType';
  const base = isContingent ? 'ContingentBenefitPercentage' : 'BenefitPercentage';

  const suffixMatch = beneTypeQuestionId.match(/_(\d+)$/);
  if (suffixMatch) {
    return `${base}_${suffixMatch[1]}`;
  }

  if (Number.isInteger(listIndex) && listIndex >= 0) {
    return `${base}_${listIndex + 1}`;
  }

  return base;
};

export const stripBenefitPercentageFromAnswers = (answers, beneTypeQuestionId, listIndex) => {
  const pctId = getBenefitPercentageQuestionId(beneTypeQuestionId, listIndex);
  return answers.map((entry) => {
    if (entry.question_id === pctId) {
      return { ...entry, answer: '' };
    }
    return entry;
  });
};

/** Normalize dropdown / single-select values for equality checks. */
export const normalizeSelectionId = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (isPlainObject(value) && value.id !== undefined && value.id !== null) {
    return String(value.id);
  }
  if (isArray(value) && value.length > 0) {
    return normalizeSelectionId(value[0]);
  }
  return String(value);
};

export const isSameSelectionValue = (previous, current) =>
  normalizeSelectionId(previous) === normalizeSelectionId(current);
